// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SectionFAQPromo_searchInput__Yt_Rl"};